import SolidBtn from "@fuse/sharedComponents/buttons/SolidBtn"
import { LetsHangDownloadHeader } from "@fuse/sharedComponents/legacyUI/Top/DownloadButton"
import "@fuse/sharedComponents/legacyUI/Top/style.css"
import { greyColor } from "@fuse/sharedComponents/legacyUI/Top/styles"
import FancyText from "@fuse/sharedComponents/typography/FancyText"

import First from "@fuse/assets/images/legacy/img-page-not-found.svg"

export interface PropsTypes {
  onHomePage: () => void
}

export default function EmptyEvent({ onHomePage }: PropsTypes) {
  return (
    <div className="md:mt-[78] mt-[50px] mx-[30px] md:mx-[50px] lg:mx-[100px] xl:mx-[200px] h-[82vh]">
      <LetsHangDownloadHeader />
      <div className="flex items-center justify-center">
        <div className="md:flex flex-1 max-w-screen-lg items-center justify-center">
          <div className="flex-1 lg:flex items-center justify-center">
            <img src={First} alt="First" className="hero-image" />
          </div>
          <div className="flex-1 justify-between text-start mb-[73px] md:mb-[80px] mt-5 md:mt-0">
            <p className="text-[38px] md:text-[38px] lg:text-[48px] xl:text-[58px] space-[-0.658px] tracking-[-0.658px] font-bold text-center">
              Group not found
            </p>
            <div className="my-[26px] md:my-[30px]">
              <FancyText
                className="text-[15px] md:text-[18px] mb-[10px] md:mb-[10px] text-center"
                style={greyColor}
              >
                Oops! We couldn't find the group you're looking for. Please try
                again later.
              </FancyText>
            </div>
            <div className="flex items-center justify-center">
              <SolidBtn
                // style={{ borderColor: Colors.primary }}
                className="mr-4 px-6 lg:px-8"
                onClick={() => onHomePage()}
              >
                <p className="text-[12px] md:text-[15px]">Back to home page</p>
              </SolidBtn>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
